import { useSyncExternalStore } from 'react';
import type { AppController, AppSnapshot } from '@/call/app-controller';

/**
 * Підписка на стан контролера. Медіаобʼєкти в стан React не кладуться —
 * лише посилання, яке компонент віддає у `<video>` через ref.
 */
export function useAppSnapshot(controller: AppController): AppSnapshot {
  return useSyncExternalStore(
    (listener) => controller.subscribe(() => {
      listener();
    }),
    () => controller.snapshot(),
  );
}
